function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "gmail",
  transform: "translate(-3 -8)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  d: "M45,16.2l-5,2.75L35,23.7V40h7a3,3,0,0,0,3-3Z",
  fill: "#4caf50"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  d: "M3,16.2l3.614,1.71L13,23.7V40H6a3,3,0,0,1-3-3Z",
  fill: "#1e88e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  d: "M35,11.2,24,19.45,13,11.2,12,17l1,6.7,11,8.25L35,23.7,36,17Z",
  fill: "#e53935"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_8",
  d: "M3,12.3v3.9l10,7.5V11.2L9.876,8.859A4.3,4.3,0,0,0,7.3,8h0A4.3,4.3,0,0,0,3,12.3Z",
  fill: "#c62828"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  d: "M45,12.3v3.9L35,23.7V11.2l3.124-2.341A4.3,4.3,0,0,1,40.7,8h0A4.3,4.3,0,0,1,45,12.3Z",
  fill: "#fbc02d"
}));

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.dcc66b4b.svg";
export { ForwardRef as ReactComponent };